import { useState } from 'react';
import { Container, Content, Title, Options, Option, Logo } from './Line.style';
import DrReckeweg from '../../assets/Lines/white-logos/dr-reckeweg-blanco.png';
import Tegor from '../../assets/Lines/white-logos/tegor-blanco.png';
import Helixor from '../../assets/Lines/white-logos/helixor-blanco.png';
import Symbio from '../../assets/Lines/white-logos/symbio-blanco.png';
import Regenhial from '../../assets/Lines/white-logos/regenhial-blanco.png';
import { Link } from 'react-router-dom';

const brandLogos = {
  drReckeweg: DrReckeweg,
  tegor: Tegor,
  helixor: Helixor,
  symbio: Symbio,
  regenhial: Regenhial
};

const Line = ({ brand, title, options = [] }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Container background={brand} onClick={handleToggle} expanded={expanded}>
      <Content expanded={expanded}>
        <Logo>
          <img src={brandLogos[brand] || DrReckeweg} alt={brand} />
        </Logo>
        {expanded && (
          <>
            <Title>{title}</Title>
            <Options>
              {options.map((option) => (
                <Option as={Link} to={`/lineas/${brand}/${option.id}/${option.firstProductId}`} key={option.id}>{option.name}</Option>
              ))}
            </Options>
          </>
        )}
      </Content>
    </Container>
  );
};

export default Line;
